const Footer = () => {
  return (
    <footer className="mt-12 flex w-full flex-col items-center justify-between gap-3 border-t border-border pt-6 text-sm text-muted-foreground sm:flex-row">
      <p className="text-center">
        ©{new Date().getFullYear()} Wasaa Markets. All rights reserved.
      </p>
      <ul className="flex flex-wrap items-center gap-6">
        <li>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://wasaa.markets"
            className="font-medium text-muted-foreground transition-colors hover:text-foreground"
          >
            Website
          </a>
        </li>
        <li>
          <a
            href="mailto:support@wasaa.markets"
            className="font-medium text-muted-foreground transition-colors hover:text-foreground"
          >
            Support
          </a>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
